// @ts-expect-error untyped module reference-resolvers
import { CONTACT_LIST } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { contactListUrl } from 'automation-ui-references/routing/hubspotUrls';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <ContactListName id="123" />
 * Renders as:
 *   My List Name
 */
const ContactListName = ({
  id,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  href: href || contactListUrl(id),
  id: id,
  messageKey: messageKey,
  referenceObjectType: CONTACT_LIST
});
export default ContactListName;